var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-card',{attrs:{"client":_vm.client,"dismiss":_vm.dismiss,"loading":_vm.loading,"on-submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }